import { useLazyQuery, useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { Flex, Text, Card } from 'rebass/styled-components'
import { Skeleton } from '../../components/loadingSkeleton/Skeleton';
import { GET_CURRENT_INTAKE_VALUES } from '../../graphql/queries';
import { IAllergyHistory, IFamilyHistory, IGetPatientIntakeValuesInput, IGetPatientIntakeValuesOutput, IGetProviderCurrentIntakeValues, IMedicalHistory, IPatientProblemsHistory, ISurgicalHistory } from '../../graphql/types/queries/charts';
import { Medications } from './components/Medications';
import { useIsVisible } from '../../hooks/useIsVisible';

interface IAllergiesProps {
  id: string
}

const RND_SIZES = [150, 137, 187, 211, 111, 237]

const LoadingPlaceholder = () => {
  return <Flex flexDirection={'column'} width='100%' padding={'20px'}>
    <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #FFABA0' }} paddingY={'12px'} mb={4}>
      <Text fontWeight={600} fontSize='18px' m={'18px 12px'}>Allergies</Text>
      {[0, 1, 2, 3].map(x => {
        return <Skeleton width={RND_SIZES[Math.floor(Math.random() * RND_SIZES.length)]} />
      })}
    </Flex>
  </Flex>
}

export const Allergies: React.FC<IAllergiesProps> = ({ id }) => {
  const [showActiveAllergies, setShowActiveAllergies] = useState<boolean>(true)
  const ref = useRef<any>();
  const isVisible = useIsVisible(ref);
  const [load, { data, loading, error }] = useLazyQuery<IGetPatientIntakeValuesOutput, IGetPatientIntakeValuesInput>(GET_CURRENT_INTAKE_VALUES, {
    variables: {
      id
    }
  })

  useEffect(() => {
    if (!!isVisible) {
      load()
    }
  }, [isVisible])
  if (loading) return <LoadingPlaceholder />

  return (
    <Flex ref={ref} flexDirection={'column'} width='100%' padding={'20px'}>
      {loading ? (<LoadingPlaceholder />) : (
        <>
          <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #FFABA0' }} paddingY={'12px'} mb={4}>
            <Flex flexDirection={['column', 'row', 'row']} m={'18px 12px'} alignItems='baseline'>
              <Text fontWeight={600} fontSize='18px' marginRight={[0, '18px', '18px']} marginBottom={['12px', 0, 0]}>{`${!showActiveAllergies ? 'Historical ' : ''}Allergies`}</Text>
              <Text fontWeight={300} fontSize='14px' color={'#7092c7'} style={{ cursor: 'pointer' }} onClick={() => setShowActiveAllergies(!showActiveAllergies)}>{`${showActiveAllergies ? `HISTORICAL (${((data?.getProviderCurrentIntakeValues || {}).allergies || []).filter(x => x.deactivatedate).length})` : `ACTIVE (${((data?.getProviderCurrentIntakeValues || {}).allergies || []).filter(x => !x.deactivatedate).length})`}`}</Text>
            </Flex>

            {((data?.getProviderCurrentIntakeValues || {} as IGetProviderCurrentIntakeValues).allergies || [] as IAllergyHistory[]).filter(x => {
              if (!showActiveAllergies) {
                return !!x.deactivatedate
              }
              return !x.deactivatedate
            })
              .map(x => {
                return (
                  <Flex p={2} ml='12px' mt={2} flexDirection={'column'} key={x.allergenid} style={{ borderLeft: '3px solid #f8a2945c' }}>
                    <Text>{x.allergenname} {!!x.criticality ? `, ${x.criticality} criticality` : ``}</Text>
                    {(x.reactions || []).map(y => (
                      <Text fontSize={'14px'} ml={1} fontWeight={300} color='#59575d' key={y.snomedcode}>{y.reactionname}, {y.severity}</Text>
                    ))}
                    {!showActiveAllergies ? (
                      <Text opacity={0.7} fontSize={'12px'} mt={1} ml={1} fontWeight={300} color='#59575d' key={`${x.allergenid}-deletedBy`}>Deleted by {x.deactivateduser} | {x.deactivatedate}</Text>
                    ) : (
                      <Text opacity={0.7} fontSize={'12px'} mt={1} ml={1} fontWeight={300} color='#59575d' key={`${x.allergenid}-updatedby`}>Last updated by {x.lastmodifiedby}</Text>
                    )}
                  </Flex>
                )
              })}
            {(!data || !data.getProviderCurrentIntakeValues || !data.getProviderCurrentIntakeValues.allergies || data.getProviderCurrentIntakeValues.allergies.length < 1) && (
              <Text color='#a2aab6' textAlign={'center'}>No allergy data</Text>
            )}
          </Flex>

        </>
      )}
    </Flex>);
}